export const getYearStructure = data => data.map(item => ({ value: item, label: String(item) }))
export const getMakesStructure = data => data.map(item => ({ value: item.makeId, label: item.makeDesc }))
export const getModelStructure = data => data.map(item => ({ value: item.modelId, label: String(item.modelName) }))
export const getSubModelStructure = data => data.map(item =>
  ({ value: item.subModelId, label: String(item.subModelDesc) }))

